var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Label3 } from "@irati/ui/src/Labels";
import { PADDING } from "../constants";
var Text = styled(Label3)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n  left: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  ",
    "\n  left: 0;\n  right: 0;\n"])), function (_a) {
    var size = _a.size;
    return "\n    top: " + (size - PADDING) / 2 + "px;\n  ";
});
export default Text;
var templateObject_1;
